export { default } from './PaymentResign';
